import {
  MITRE_TACTIC_LIST_SET,
  MITRE_TACTIC_LIST_REQ,
  MITRE_TACTIC_LIST_SUCCESS,
  MITRE_TACTIC_LIST_ERROR,
  MITRE_TECHNIQUE_LIST_SET,
  MITRE_TECHNIQUE_LIST_REQ,
  MITRE_TECHNIQUE_LIST_SUCCESS,
  MITRE_TECHNIQUE_LIST_ERROR,
  MITRE_COVERAGE_SET
} from './mitre-attack.type'

import ApiRest from '@/api/api-rest'
import MitreTactic from '@/resources/models/MitreTactic'
import MitreTechnique from '@/resources/models/MitreTechnique'

const state = {
  mitreTacticListReqStatus: '',
  mitreTacticList: {},
  mitreTechniqueListReqStatus: '',
  mitreTechniqueList: {},
  mitreCoverageMarked: false
}

const getters = {
  mitreTacticListReqStatus: state => state.mitreTacticListReqStatus,
  mitreTacticList: state => state.mitreTacticList,
  mitreTechniqueListReqStatus: state => state.mitreTechniqueListReqStatus,
  mitreTechniqueList: state => state.mitreTechniqueList,
  mitreCoverageMarked: state => state.mitreCoverageMarked
}

// Best Practice - updates state
const mutations = {
  [MITRE_TACTIC_LIST_SET]: (state, data) => {
    state.mitreTacticList = data
  },
  [MITRE_TACTIC_LIST_REQ]: state => {
    state.mitreTacticListReqStatus = 'loading'
  },
  [MITRE_TACTIC_LIST_SUCCESS]: (state, data) => {
    state.mitreTacticListReqStatus = 'saved'
  },
  [MITRE_TACTIC_LIST_ERROR]: (state, errMsg) => {
    state.mitreTacticListReqStatus = 'error'
  },
  [MITRE_TECHNIQUE_LIST_SET]: (state, data) => {
    state.mitreTechniqueList = data
    // map techniqure to appropriate attack tactic
    if (!_.isEmpty(state.mitreTacticList)) {
      state.mitreTacticList.forEach(tactic => {
        let filterTechniques = _.filter(state.mitreTechniqueList, technique => {
          return _.some(technique.kill_chain_phases, {
            phase_name: tactic['x_mitre_shortname']
          })
        })
        tactic.appendTechniques(filterTechniques)
      })
    }
  },
  [MITRE_TECHNIQUE_LIST_REQ]: state => {
    state.mitreTechniqueListReqStatus = 'loading'
  },
  [MITRE_TECHNIQUE_LIST_SUCCESS]: (state, data) => {
    state.mitreTechniqueListReqStatus = 'saved'
  },
  [MITRE_TECHNIQUE_LIST_ERROR]: (state, errMsg) => {
    state.mitreTechniqueListReqStatus = 'error'
  },
  [MITRE_COVERAGE_SET]: (state, covered) => {
    state.mitreCoverageMarked = covered
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [MITRE_COVERAGE_SET] (context, covered) {
    context.commit(MITRE_COVERAGE_SET, covered)
  },
  [MITRE_TACTIC_LIST_REQ] (context) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('static/json/mitre-enterprise-attack-tactics.json')
        .then(({ data }) => {
          let tactics = _.map(data.objects, tactic => {
            return new MitreTactic('name', tactic)
          })
          context.commit(MITRE_TACTIC_LIST_SET, tactics)
          context.commit(MITRE_TACTIC_LIST_SUCCESS)
          resolve(tactics)
        })
        .catch(errMsg => {
          context.commit(MITRE_TACTIC_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [MITRE_TECHNIQUE_LIST_REQ] (context) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('static/json/mitre-enterprise-attack-techniques.json')
        .then(({ data }) => {
          let techniques = _.map(data.objects, technique => {
            return new MitreTechnique('id', technique)
          })
          context.commit(MITRE_TECHNIQUE_LIST_SET, techniques)
          context.commit(MITRE_TECHNIQUE_LIST_SUCCESS)
          resolve(techniques)
        })
        .catch(errMsg => {
          context.commit(MITRE_TECHNIQUE_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/mitre-attack/mitre-attack.module.js